import gql from 'graphql-tag';


export const VALIDATE_SERIAL = gql`
  query validateSerialMetadata(
    $referenceId: String
    $referenceLineItemId: String
    $mpn: String
    $manufacturer: String
    $ipn: String
    $serialId: String
    $siteSpecificSerial: Boolean
    $inventoryAdjustmentWorkflow: Boolean
    $rmaIdWorkflow: Boolean
  ) {
    validateSerialMetadata(
      referenceId: $referenceId
      referenceLineItemId: $referenceLineItemId
      mpn: $mpn
      manufacturer: $manufacturer
      ipn: $ipn
      serialId: $serialId
      siteSpecificSerial: $siteSpecificSerial
      inventoryAdjustmentWorkflow: $inventoryAdjustmentWorkflow
      rmaIdWorkflow: $rmaIdWorkflow
    ) {
      serialId
      externalReferenceValue
      referenceId
      status {
        validationStatusType
        statusCode
        statusMessage
      }
    }
  }
`;

export const VALIDATE_SERIALS = gql`
  query validateSerialsMetadata($serials: [SerialsInput]) {
    validateSerialsMetadata(serials: $serials) {
      serials {
        id
        serialId
        externalReferenceValue
        referenceId
        status {
          validationStatusType
          statusCode
          statusMessage
        }
      }
    }
  }
`;
